import api from "../../configs/api";
import { CreatePaymentOrder, CreatePaymentVisitor } from "../../types";

export class PaymentCreationError extends Error {
  code?: string;

  status?: number;

  constructor(message: string, code?: string, status?: number) {
    super(message);
    this.name = "PaymentCreationError";
    this.code = code;
    this.status = status;
  }
}

const paymentCreationError = (error: any) => {
  const data = error?.response?.data;
  return new PaymentCreationError(
    data?.message || "Falha ao iniciar o pagamento",
    data?.errorCode || data?.error_code,
    error?.response?.status,
  );
};

export const getPaymentCreationErrorMessage = (error: unknown) => {
  if (!(error instanceof PaymentCreationError)) return "Falha ao iniciar o pagamento. Tente novamente.";
  if (error.code === "CHECKOUT_OUT_OF_STOCK") return "Um ou mais produtos acabaram de ficar indisponíveis. Revise seu carrinho para continuar.";
  const message = error.message.toLowerCase();
  if (message.includes("not linked") || message.includes("não vinculado")) return "Nenhuma máquina de pagamento está vinculada a este totem.";
  if (message.includes("offline")) return "A máquina de pagamento está offline. Verifique o equipamento antes de continuar.";
  if (message.includes("busy") || message.includes("ocupad")) return "A máquina de pagamento está processando outra compra.";
  if (message.includes("does not support") || message.includes("não suporta")) return "A máquina vinculada não suporta este pagamento.";
  return "Falha ao iniciar o pagamento. Tente novamente.";
};

export const getClientTransaction = async (transactionId: string) => {
  try {
    const { status, data } = await api.get(
      `/virtual-card/recharge/${transactionId}`,
    );

    if (status !== 200) throw new Error();

    return data;
  } catch (error) {
    throw paymentCreationError(error);
  }
};

export const createPaymentVisitor = async (dto: CreatePaymentVisitor) => {
  try {
    const { status, data } = await api.post("/virtual-card/payment", dto);

    if (status !== 201) throw new Error();

    return data;
  } catch (error) {
    throw paymentCreationError(error);
  }
};

export const createPaymentIndividual = async (dto: CreatePaymentVisitor) => {
  try {
    const { status, data } = await api.post("/virtual-card/payment", dto);

    if (status !== 201) throw new Error();

    return data;
  } catch (error) {
    throw paymentCreationError(error);
  }
};

export const createPaymentOrder = async (dto: CreatePaymentOrder) => {
  try {
    const { status, data } = await api.post("/payment-order", dto);

    if (status !== 201) throw new Error();

    return data;
  } catch (error) {
    throw paymentCreationError(error);
  }
};
